"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowDownCircle = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ArrowDownCircle = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 12C0 5.373 5.373 0 12 0a12 12 0 0112 12c0 6.627-5.373 12-12 12S0 18.627 0 12zm12.432 2.22l3.6-3.6A.6.6 0 0015.6 9.6H8.4a.6.6 0 00-.42 1.02l3.6 3.6c.237.23.615.23.852 0z", clipRule: "evenodd" })); };
exports.ArrowDownCircle = ArrowDownCircle;
//# sourceMappingURL=arrow-down-circle.js.map